<template>
  <div
    v-if="!isCompetitiveChart"
    class="data-type-badge"
    :style="badgeStyle"
  >
    <v-btn
      v-tooltip="tooltip"
      text
      min-width="12"
      min-height="6"
      small
    >
      <span class="data-type-badge__content">{{ initials }}</span>
    </v-btn>
  </div>
</template>

<script>
import colors from '@/utils/colors';
import { DATA_TYPE, DATA_TYPE_INITIALS, DATA_TYPE_TOOLTIP } from '@/store/modules/cards/constants';

export default {
  name: 'DataTypeBadge',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dataType: this.value.toUpperCase(),
    };
  },
  computed: {
    badgeStyle() {
      return {
        'background-color': this.color.rgba,
        'border': `1px solid${this.color.color}`,
      };
    },
    tooltip() {
      return DATA_TYPE_TOOLTIP[this.value];
    },
    initials() {
      return DATA_TYPE_INITIALS[this.value];
    },
    color() {
      return colors.dataType[this.value];
    },
    isCompetitiveChart() {
      return this.value === DATA_TYPE.COMPETITIVE;
    },
  },
};
</script>
<style scoped lang="scss">
  .data-type-badge {
    display: inline-flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    border-radius: var(--ds-border-radius-sm);
    min-width: 24px;
    max-width: 30px;
    height: 16px;
    margin: var(--ds-spacing-stack-quark) var(--ds-spacing-inline-nano) 0 0;

    &__content {
      font-weight: var(--ds-font-weight-bold);
      font-size: 10px;
      line-height: 16px;
      color: var(--ds-color-text-2);
    }
  }

  .v-btn::before {
    background-color: transparent;
  }
</style>
